import React, { useState, useEffect } from "react";
import CustomInput from "../../../components/CustomInput/CustomInputValidate";
import BucketUploader from "../../../components/FileUploader/BucketUploader";
import { clone } from "../../../shared/utility";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import CustomCheckbox from "../../../components/CustomCheckbox/CustomCheckbox";
import { IconButton, TextField } from "@material-ui/core";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import Button from "../../../components/CustomButtons/Button";
import NotificationAsk from "../../../components/Notification/NotificationAsk";
import { website_property_primary_types, website_property_secondary_types } from "./PropertiesObj";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import HighlightsListInput from "../../../components/HighlightsListInput/HighlightsListInput";

const GraySwitch = withStyles({
    switchBase: {
        color: "#f5f5f5",
        "&$checked": {
        transform: "translateX(18px)",
        color: "#fff"
        },
        "&$checked + $track": {
        backgroundColor: "#da2229",
        opacity: 1
        }
    },
    checked: {},
    track: {
        backgroundColor: "#dcdcdc",
        opacity: 1
    }
})(Switch);

const PropertiesFormWebsiteData = props => {
    const [toDelete, setAskToDelete] = useState(null);
    console.log('PropertiesFormWebsiteData', props)
    const objj = {
        brochure_upload: '',
        title: '',
        property_description: '',
        highlights: '',
        highlights2: '',
        features: '',

        lease_rate: '',
        price: '',
        total_space_available: '',
        property_type: '',
        secondary_use: '',
        // is_second_generation: '',
        parking_ration: '',
        gross_leaseable: '',
        site_area: ''
    };
    const { dataObj, setDataObj } = props;
    const obj = {
        brochure_upload: 'Brochure upload',
        title: 'Title / Headline',
        property_description: 'Property Description',
        highlights: 'Highlights Column One',
        highlights2: 'Highlights Column Two',
        features: 'Features',

        // 'Lease Rate or Price (if it`s a sale) or both if its for lease and sale',
        // 'Total Space Available (SF Available)',
        // 'Property Type',
        // 'Parking Ratio',
        // 'Gross Leaseable Area (if for sale)',
        // 'Site Area (if for sale)'
    }
    const data = dataObj.json_data ? dataObj.json_data : objj;
    const feature_options = [
        'Air Conditioning',
        'Balcony',
        'Controlled Access',
        'Fenced Lot',
        'Signage',
        'Outdoor Seating',
        'Reception',
        'Restaurant',
        'Security System',
        'Storage Space'
    ]
    const oms = [
        'Lease Rate or Price (if it`s a sale) or both if its for lease and sale',
        'Total Space Available (SF Available)',
        'Property Type',
        'Parking Ratio',
        'Gross Leaseable Area (if for sale)',
        'Site Area (if for sale)'
    ]

    const property_facts_obj = {
        //lease_rate: 'Lease Rate',
        //price: 'Price',
        //total_space_available: 'Total Space Available',
        property_type: 'Property Type',
        secondary_use: 'Secondary Use',
        // is_second_generation: 'Is Second Generation?',
        parking_ration: 'Parking Ratio',
        //gross_leaseable: 'Gross Leasable',
        //site_area: 'Site Area',
        google_maps_embed_code: 'Google Maps Embed Code'
    }

    const moveAdditionalLink = (fromIndex, toIndex) => {
        if (toIndex < 0 || toIndex >= data.additional_links.length) return;

        const newDataObj2 = clone(dataObj);
        const newData2 = clone(data);

        const items = newData2.additional_links;

        // swap
        const temp = items[fromIndex];
        items[fromIndex] = items[toIndex];
        items[toIndex] = temp;

        newDataObj2.json_data = newData2;
        setDataObj(newDataObj2);
    };

    return <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
            <h3>WEBSITE PROPERTY LISTING DATA</h3>
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
            <CustomInput 
                label="Title / Heading"
                onChange={(e) => {
                    const newDataObj = clone(dataObj);
                    const newData = clone(data);
                    newData.title = e.target.value;
                    newDataObj.json_data = newData;
                    setDataObj(newDataObj);
                }}
                value={data.title}
            />
            <hr />
            <TextField
                label="Property Description"
                multiline
                rows={4}
                margin="normal"
                onChange={(e) => {
                    const newDataObj = clone(dataObj);
                    const newData = clone(data);
                    newData.property_description = e.target.value;
                    newDataObj.json_data = newData;
                    setDataObj(newDataObj);
                }}
                value={data.property_description}
                style={{width:'100%'}}
            />
        </GridItem>
        <GridItem xs={4} sm={4} md={4}>
            <HighlightsListInput
                label="Highlights Column One"
                value={data.highlights}
                readOnly={props.action === "View"}
                onChange={(val) => {
                    const newDataObj = clone(dataObj);
                    const newData = clone(data);
                    newData.highlights = val;
                    newDataObj.json_data = newData;
                    setDataObj(newDataObj);
                }}
            />
        </GridItem>
        <GridItem xs={4} sm={4} md={4}>
            <HighlightsListInput
                label="Highlights Column Two"
                value={data.highlights2}
                readOnly={props.action === "View"}
                onChange={(val) => {
                    const newDataObj = clone(dataObj);
                    const newData = clone(data);
                    newData.highlights2 = val;
                    newDataObj.json_data = newData;
                    setDataObj(newDataObj);
                }}
            />
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
            <h3>Features</h3>
            {feature_options.map((fo,foi) => {
                const checked = data.features ? data.features.indexOf(fo) !== -1 : false;
                return <CustomCheckbox 
                    key={`ccb-${foi}`}
                    checked={checked ? true : false}
                    onChange={() => {
                        const newDataObj = clone(dataObj);
                        const data = newDataObj.json_data ? newDataObj.json_data : obj;
                        const newData = clone(data);
                        if (!data.features) {
                            newData.features = '';
                        }
                        let new_feature_options = newData.features.split(',');
                        if (checked) {
                            new_feature_options = new_feature_options.filter(f => {
                                if (f !== fo) return true
                            });
                        } else {
                            new_feature_options.push(fo);
                        }
                        newData.features = new_feature_options.join(',');
                        newDataObj.json_data = newData;
                        setDataObj(newDataObj);
                    }}
                    label={fo}
                />
            })}
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
            <BucketUploader 
                disabled={false}
                title="Property Brochure"
                update={(val, alt) => {
                    const newDataObj = clone(dataObj);
                    const data = newDataObj.json_data ? newDataObj.json_data : obj;
                    const newData = clone(data);
                    newData.brochure_upload = val;
                    newDataObj.json_data = newData;
                    setDataObj(newDataObj);
                }}
                remove={() => {
                    const newDataObj = clone(dataObj);
                    const data = newDataObj.json_data ? newDataObj.json_data : obj;
                    const newData = clone(data);
                    newData.brochure_upload = val;
                    newDataObj.json_data = newData;
                    setDataObj(newDataObj);
                }}
                the_filename={data.brochure_upload}
                type="crm"
                canEdit={true}
                show_image={true}
            />
        </GridItem>
        <GridItem xs={4} sm={12} md={12}>
            <h3>PROPERTY FACTS</h3>
        </GridItem>
        <GridItem xs={4} sm={4} md={4}>
            <CustomInput 
                label="Asking Price"
                onChange={(e) => {
                    let value = e?.target?.value ?? e ?? '';

                    // 1. Remove anything that's not a number or dot
                    value = value.replace(/[^0-9.]/g, '');

                    // 2. Allow only ONE dot
                    const parts = value.split('.');
                    if (parts.length > 2) {
                        value = parts[0] + '.' + parts.slice(1).join('');
                    }

                    const newDataObj = clone(dataObj);
                    newDataObj.asking_price = value;
                    setDataObj(newDataObj);
                }}
                isDollar={true}
                is_dollar={true}
                value={dataObj.asking_price}
            />
        </GridItem>
        <GridItem xs={4} sm={4} md={4}></GridItem>
        <GridItem xs={4} sm={4} md={4}></GridItem>
        {Object.keys(property_facts_obj).map(f => {
            if (f === 'google_maps_embed_code') {
                return <GridItem xs={4} sm={4} md={4} key={f}>
                    <TextField
                        label="Enter Google Maps Embed Code"
                        multiline
                        rows={4}
                        variant="outlined"   // or "standard" / "filled"
                        fullWidth
                        value={data[f]}
                        onChange={(e) => {
                            const newDataObj = clone(dataObj);
                            const newData = clone(data);
                            newData[f] = e.target.value;
                            newDataObj.json_data = newData;
                            setDataObj(newDataObj);
                        }}
                    />
                </GridItem>
            }
            if (f === 'is_second_generation') {
                return null;
                return <GridItem xs={4} sm={4} md={4} key={f}><FormControlLabel
                    label="Is this space Second-Generation?"
                    control={
                        <GraySwitch
                            checked={data.is_second_generation === "Yes"}
                            onChange={(e, checked) => {
                                const newDataObj = clone(dataObj);
                                const newData = clone(data);
                                newData.is_second_generation = checked ? "Yes" : "";
                                newDataObj.json_data = newData;
                                console.log('changing', e, e.target.checked, checked, newData);
                                setDataObj(newDataObj);
                            }}
                        />
                    }
                    />
                </GridItem>
            }
            if (f === 'property_type') {
                return <GridItem xs={4} sm={4} md={4} key={f}>
                    <CustomSelect 
                        default={data[f]}
                        options={website_property_primary_types}
                        label="Property Type"
                        choose={(e, n) => {
                            const newDataObj = clone(dataObj);
                            const newData = clone(data);
                            newData[f] = e;
                            if (e !== data[f]) {
                                // changed, reset Secondary Use
                                newData.secondary_use = '';
                            }
                            newDataObj.json_data = newData;
                            setDataObj(newDataObj);
                        }}
                    />
                    <CustomSelect 
                        default={data.secondary_use}
                        options={website_property_secondary_types[data[f]] ? website_property_secondary_types[data[f]] : []}
                        label="Secondary Use"
                        choose={(e, n) => {
                            const newDataObj = clone(dataObj);
                            const newData = clone(data);
                            newData.secondary_use = e;
                            newDataObj.json_data = newData;
                            setDataObj(newDataObj);
                        }}
                    />
                </GridItem>
            }
            if (f === 'secondary_use') {
                return null;
            }
            return <GridItem xs={4} sm={4} md={4} key={f}>
                <CustomInput 
                    label={property_facts_obj[f]}
                    onChange={(e) => {
                        const newDataObj = clone(dataObj);
                        const newData = clone(data);
                        newData[f] = e.target.value;
                        newDataObj.json_data = newData;
                        setDataObj(newDataObj);
                    }}
                    value={data[f]}
                />
            </GridItem>
        })}
        <GridItem xs={12} sm={12} md={12}></GridItem>
        <GridItem xs={4} sm={4} md={4}>
            <h3>Additional Links</h3>
            <Button color="primary" onClick={() => {
                const newDataObj = clone(dataObj);
                const newData = clone(data);
                if (!newData.additional_links) {
                    newData.additional_links = [{
                        url: '',
                        description: ''
                    }];
                } else {
                    newData.additional_links.unshift({
                        url: '',
                        description: ''
                    });
                }
                newDataObj.json_data = newData;
                setDataObj(newDataObj);
            }}>ADD LINK</Button>
            {toDelete !== null && <NotificationAsk 
                title="Are you sure?"
                content={<>
                    <p>Do you want to remove this additional link?</p>
                </>}
                success={() => {
                    const newDataObj2 = clone(dataObj);
                    const newData2 = clone(data);
                    newData2.additional_links = newData2.additional_links.filter((adl,i) => {
                        if (i === toDelete) {
                            return false;
                        }
                        return true;
                    })
                    newDataObj2.json_data = newData2;
                    setDataObj(newDataObj2);
                    setAskToDelete(null);
                }}
                open={true}
                close={() => {
                    setAskToDelete(null);
                }}
            />}
            {data.additional_links && <>
                <div>
                    {data.additional_links.map((adl,indx) => {
                        
                        return <div className="boxed mt-20" key={`nadl-${indx}`}>
                            <IconButton
                                onClick={() => {
                                    setAskToDelete(indx);
                                }}
                                className="mr-20"
                            >
                                <i className="red-text fa fa-trash"></i>
                            </IconButton>
                            <IconButton
                                disabled={indx === 0}
                                onClick={() => moveAdditionalLink(indx, indx - 1)}
                                className="mr-20"
                            >
                                <i className="fa fa-chevron-up"></i>
                            </IconButton>
                            <IconButton
                                disabled={indx === data.additional_links.length - 1}
                                onClick={() => moveAdditionalLink(indx, indx + 1)}
                                className="mr-20"
                            >
                                <i className="fa fa-chevron-down"></i>
                            </IconButton>
                            <CustomInput 
                                label="URL / Link"
                                onChange={(e) => {
                                    const newDataObj2 = clone(dataObj);
                                    const newData2 = clone(data);
                                    newData2.additional_links[indx].url = e.target.value;
                                    newDataObj2.json_data = newData2;
                                    setDataObj(newDataObj2);
                                }}
                                value={adl.url}
                            />
                            <CustomInput 
                                label="Label"
                                onChange={(e) => {
                                    const newDataObj2 = clone(dataObj);
                                    const newData2 = clone(data);
                                    newData2.additional_links[indx].description = e.target.value;
                                    newDataObj2.json_data = newData2;
                                    setDataObj(newDataObj2);
                                }}
                                value={adl.description}
                            />
                        </div>
                    })}
                </div>
            </>}
            
        </GridItem>
        <GridItem xs={4} sm={4} md={4}>

        </GridItem>
    </GridContainer>
}

export default PropertiesFormWebsiteData;